import React, { useCallback, useMemo } from 'react';
import DNAEmpty, { EmptyVariant } from 'src/components/DNA/Empty/DNAEmpty';
import MeetingTable from 'src/components/Meeting/MeetingTable';
import { useMeetingList } from 'src/state/redux/selector/meeting';
import orderBy from 'lodash/orderBy'
import { MeetingORM } from 'src/types/orms';
import {
  DNABox,
  DNAButton,
  Iffy,
} from '@alucio/lux-ui';
import { useDispatch } from 'src/state/redux';
import { drawerActions, DRAWER_ENTITIES } from 'src/state/redux/slice/drawer';
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags';
import { TitleBar } from 'src/components/DNA';

export const isNotDeleted = (item: unknown) : item is MeetingORM => item
  ? (item as MeetingORM).model.status !== 'DELETED'
  : false

const useDNAMeetingsSharedComponents = () => {
  const meetingList = useMeetingList();
  const dispatch = useDispatch();
  const enableAddNewMeeting = useFeatureFlags('enableAddNewMeeting');

  const sortedMeetings = useMemo(
    () => {
      const visibleMeetings = meetingList.filter(isNotDeleted)
      return orderBy(visibleMeetings, ['model.startTime'], ['desc'])
    },
    [meetingList],
  )

  const onAddMeeting = useCallback(
    () => {
      dispatch(drawerActions.toggle({ entity: DRAWER_ENTITIES.MEETING }));
    },
    [],
  );
  return {
    sortedMeetings,
    onAddMeeting,
    enableAddNewMeeting,
  }
}

const DNAMeetingsHistory: React.FC = () => {
  const { sortedMeetings, onAddMeeting, enableAddNewMeeting } = useDNAMeetingsSharedComponents()

  return (
    <DNABox
      alignX="center"
      fill
    >
      <DNABox
        fill
        alignX="center"
      >
        <DNABox fill spacing="md" appearance="col" testID="page-container" childFill={1}>
          {/* Header */}
          <DNABox fill>
            <TitleBar
              title="Meeting History"
              description="Manage and track all your meetings"
              testID="meetings-history-title-bar"
            >
              <TitleBar.Button>

                <Iffy is={enableAddNewMeeting}>
                  <DNAButton
                    testID="create-meeting-button"
                    appearance="filled"
                    status="primary"
                    size="md"
                    onPress={onAddMeeting}
                  >
                    Create meeting
                  </DNAButton>
                </Iffy>

              </TitleBar.Button>
            </TitleBar>

          </DNABox>
          {
            sortedMeetings.length
              ? <MeetingTable meetingORM={sortedMeetings} />

              : <DNABox>
                <DNAEmpty
                  emptyVariant={EmptyVariant.MeetingsHistoryEmpty}
                  customEmptyLabel="Host or create meetings to find them here"
                  customEmptyActionLabel="Create meeting"
                  customEmptyOnPress={onAddMeeting}
                />
              </DNABox>
          }
        </DNABox>
      </DNABox>
    </DNABox>
  )
}

export default DNAMeetingsHistory
